export default {
  alien1 : 'alien-1',
  alien2 : 'alien-2',
  alien3 : 'alien-3',
  battleShip : 'battle-ship',
  bigCross : 'bigCross',
  bigGunTower : 'big-gun-tower',
  block : 'block',
  BlockadeRunner : 'blockade-runner',
  blueSun : 'blueSun',
  buildings : 'buildings',
  button : 'button',
  city : 'city',
  crawler : 'crawler',
  delta : 'delta',
  drones : 'drones',
  dualGun : 'dual-gun',
  fighter : 'fighter-f1',
  globe : 'globe',
  graviton : 'graviton',
  gunner : 'gunner',
  gunTower : 'gun-tower',
  manta : 'manta',
  meteorLike : 'meteor-like',
  moon : 'moon',
  nebulaInspector : 'nebula-inspector',
  obstacle : 'obstacle-1',
  offBase : 'off-base',
  partickleViolet : 'partickle-violet',
  particleGreen : 'particle-green',
  piece : 'piece-1',
  projectile2 : 'projectile-2',
  projectile3 : 'projectile-3',
  racer : 'racer',
  redBlock : 'red-block',
  rocket : 'rocket',
  rower : 'rower',
  shileld : 'shileld',
  smallMoon : 'small-moon',
  speeder : 'speeder',
  supporter : 'supporter',
  tieTransporter : 'tie-transporter',
  transporter : 'transporter',
  whiteSun : 'white-sun',
  yellowSun : 'yellow-sun',
  zorak : 'zorak',
}